import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image30 from "../../../../assets/images/Blog52/image30.png";
import image29 from "../../../../assets/images/Blog52/image29.png";
import image33 from "../../../../assets/images/Blog52/image33.png";
import image22 from "../../../../assets/images/Blog52/imag22.png";
import image25 from "../../../../assets/images/Blog52/image25macro.png";
import image1 from "../../../../assets/images/Blog52/image1.png";
import image3 from "../../../../assets/images/Blog52/image3.png";
import image4 from "../../../../assets/images/Blog52/image4.png";
import image9 from "../../../../assets/images/Blog52/image9.png";
import image46 from "../../../../assets/images/Blog52/image46.png";
import image47 from "../../../../assets/images/Blog52/image47.png";
import image44 from "../../../../assets/images/Blog52/image44.png";
import image50 from "../../../../assets/images/Blog52/image50.png";
import image18 from "../../../../assets/images/Blog52/image18.png";
import image23 from "../../../../assets/images/Blog52/image23.png";
import image106 from "../../../../assets/images/Blog52/image106.png";
import image113 from "../../../../assets/images/Blog52/image113.png";
import image39 from "../../../../assets/images/Blog52/image39.png";
import image40 from "../../../../assets/images/Blog52/image40.png";
import image119 from "../../../../assets/images/Blog52/image119.png";
import image125 from "../../../../assets/images/Blog52/image125.png";

const Blog52 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – January 19th, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Geopolitics Re-Emerges, Growth Holds, Complacency Builds Quietly</p>
        <p>
          Markets opened the week under a cloud of political and geopolitical headlines, yet price action remained notably contained. Early defensive flows emerged, but they failed to translate into
          sustained stress across rates or equities. Liquidity continued to circulate, volatility stayed compressed, and participation remained broadly intact beneath headline indices that largely
          moved sideways.
        </p>
        <p>
          That calm, however, should not be mistaken for comfort. Positioning remains extended in places, hedging is thin, and expectations have adjusted higher even as headline risk has increased.
          The backdrop remains constructive, but increasingly sensitive—one where stability depends more on the absence of shocks than on fresh conviction.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Rotation, Not Retreat</p>
              <p>
                Equity structure remains intact, supported by participation rather than acceleration. The market is not pushing higher through momentum; instead, leadership continues to rotate.
                Selling pressure has been visible in concentrated areas, while equal-weight and smaller-cap exposure has absorbed flows more effectively.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image30}
                    alt="clear rotation holding SPX back"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image30)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This redistribution of leadership reinforces the view that engagement is broadening rather than intensifying. Importantly, this has occurred without material deterioration in overall
                positioning. Hedge fund activity points to caution, not capitulation, reinforcing the idea that risk is being managed rather than exited.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="hedge fund selling risk remains in a nervous market"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="no1 flow in SPX EW doesn't look like a sell"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                At the macro level, growth continues to underpin this structure. Surprise indices remain positive, and recession probabilities have moved lower, helping cushion equity markets even as
                geopolitical noise increases
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="growth up recession odds down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt="macro surprise index positives"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Politics Loud, Markets Measured</p>
              <p>
                Policy and geopolitics dominated the narrative, but markets remained disciplined in their response. Political pressure surrounding central bank independence generated significant
                attention, yet yields moved only marginally. Global central bank support helped stabilise expectations and contain spillover risk.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="FED DOJ"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="global CB leaders rally round Powell"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Rates continue to reflect this restraint. Despite hawkish policy rhetoric, the front end has yet to reprice fully, highlighting the gap between commentary and market conviction.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt="when do US2Y yields catch up with the hawkish fedspeak?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                On the geopolitical front, tariff threats and strategic manoeuvring followed a familiar escalation pattern. Price action suggests these episodes were treated as episodic, reinforcing
                the market’s tendency to view such developments as conditional.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="Kobeissi Tariff playbook"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical perspective, trend structure remains functional. Major indices continue to hold key levels, and pullbacks have been corrective rather than impulsive. However, momentum
                has slowed, and dispersion beneath the surface has increased.
              </p>
              <p>
                Sentiment indicators point to rising confidence, but protection remains limited. Put-call ratios are low, and volatility is suppressed across both equity and rates markets—conditions
                that support carry but reduce resilience to surprise.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image46}
                    alt="total Put call ratio"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image46)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image47}
                    alt="low equity p/c ratio leads to sell offs"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image47)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Volatility measures remain calm, yet this calm sits alongside elevated geopolitical risk, increasing the likelihood that any shock could travel further than expected.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt="VIX pop a risk off?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Overall positioning remains bullish but not extreme, reinforcing the idea that complacency—not excess—is the more immediate vulnerability.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="equity positioning high but not overbought top"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Stability Holds, Fault Lines Remain</p>
              <p>
                Markets navigated the week with little visible stress despite a heavy headline load. Data generally reinforced growth resilience, while flows and positioning continued to matter more
                than outright conviction. Beneath the surface, familiar pressure points remained unresolved.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>Inflation data remained benign, with headline releases failing to generate renewed rate stress. Alternative inflation measures reinforced the view that price pressures
                    remain contained for now.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image18}
                        alt="after benign CPI/PPI truflation is really subdued"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image18)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Trade dynamics remained supportive, with external demand adjusting rather than contracting. China’s influence continued to operate more through commodities and trade
                    channels than through headline macro shifts.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image23}
                        alt="China trade growing without US"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image23)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Early earnings confirmed a low-bar environment. Financials struggled to deliver positive surprises despite solid absolute results, keeping leadership concentrated
                    elsewhere.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br>Precious metals remained well supported amid geopolitical uncertainty. Price action stayed constructive, though positioning suggests sensitivity to sentiment shifts rather
                    than speculative excess.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image106}
                      alt="gold weekly close boost"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image106)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image113}
                      alt="silver on its longest run"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image113)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Digital assets stabilised following prior selling pressure. Flow dynamics suggest sellers have eased, though overhead supply remains a consideration.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image39}
                      alt="BITCOIN sellers gone?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image39)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image40}
                      alt="next selling levels above $110k?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image40)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy markets continued to react to geopolitical headlines, with price action driven more by risk premia than by underlying supply dynamics.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image119}
                        alt="Iran troubles for oil"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image119)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                With U.S. cash markets closed on Monday, early direction is set by futures and a heavy overseas data slate. The focus then shifts to{" "}
                <span className="highlightedText">China’s activity dump, UK inflation, U.S. growth and PCE, Japan policy,</span> and <span className="highlightedText">global PMIs,</span> with Davos
                headlines running in the background throughout the week.
              </p>
              <p className="highlightedText">Monday, January 19</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Market Holiday (Martin Luther King Jr. Day)
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> GDP (Q4 YoY & QoQ)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Fixed Asset Investment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> NBS Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> CPI (Headline & Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> World Economic Forum (Davos)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, January 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Loan Prime Rate (1Y, 5Y)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ZEW Economic Sentiment (Germany, Eurozone)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Treasury Bill Auctions (3M, 6M, 52W)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, January 21</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> CPI (Headline & Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> PPI, RPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Construction Spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Pending Home Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> MBA Mortgage Applications
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 20-Year Treasury Auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> President Speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> World Economic Forum (Davos)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, January 22</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> GDP Revision (Q3)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PCE Prices (Headline & Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Personal Income & Spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Corporate Profits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 10-Year TIPS Auction
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> ECB Monetary Policy Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Employment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">New Zealand:</span> CPI
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, January 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> BOJ Policy Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> BOJ Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Flash PMIs (US, Eurozone, UK, Japan)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Consumer Sentiment & Inflation Expectations
                  </p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image125}
                  alt="week ahead"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image125)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Constructive Structure, Narrowing Margin for Error</p>
              <p>
                Markets remain supported, with structure holding as volatility stays compressed and positioning remains elevated. Growth continues to cushion risk assets, while hedging remains
                limited.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Rotation continues to dominate. Broad participation supports the trend, but leadership remains selective, favouring positioning over indiscriminate exposure. Trump’s
                    Greenland push has created a risk off start to the week which sits in a seasonally weak period in mid-term presidential market years. Look to build longs into deeper pullbacks.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Precious metals remain underpinned by geopolitical and macro uncertainty. While extended positioning may introduce
                    near-term volatility, the underlying bid remains intact.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Price action suggests consolidation rather than reversal. Support has held, but conviction remains uneven as the market
                    works through positioning.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>Growth resilience, contained inflation pressures, and active policy continue to define the backdrop. This mix supports
                    engagement but leaves markets more reactive when expectations rise.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">The structure remains constructive, but the tolerance for surprise is narrowing. Calm conditions persist—yet they rest on increasingly thin protection.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="growth up recession odds down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt="VIX pop a risk off?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image106}
                    alt="gold weekly close boost"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image106)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1A_Ih3AEh_Z6mftKoB7OH_DVgd8uBHwt-PVH_m1LA4BM/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog52;
